import {StatisticParams} from '@wix/music-player';
import {EventEmitter} from 'events';

export function subscribeToEmitter<Events extends Record<Z, T>, T, Z extends keyof Events>(
  eventEmitter: EventEmitter,
  events: Events,
  listener: (eventName: Z, eventParams: Events[Z], params: StatisticParams) => void,
) {
  for (const eventName in events) {
    if (events.hasOwnProperty(eventName)) {
      eventEmitter.on(eventName, (args) => {
        listener(eventName as any, events[eventName] as any, args);
      });
    }
  }
}
